// extracted by mini-css-extract-plugin
module.exports = {"button":"Pagination_button__2x96t"};